<template>
  <mydialog :visible="dialogVisible" :title="$t('添加到收藏列表')" :width="'450px'" @close="close">
    <div class="collect-list mb-20 max-h-400 overflow-y-auto">
      <div v-for="(collect, index) in collectList" :key="index" class="border-b border-gray-lighter p-10 hover:bg-blue-50">
        <el-checkbox v-if="collect.isEdit" v-model="collect.selected" label="" :indeterminate="false">
          <el-input v-model="collect.folderName" placeholder="" size="normal" minlength="1" maxlength="12" style="width: 370px" :show-word-limit="true"></el-input>
        </el-checkbox>
        <el-checkbox v-else v-model="collect.isCollect" label="" :indeterminate="false" :disabled="adding">
          <div class="flex w-368 justify-between">
            <span>{{ collect.folderName }}</span
            ><span>{{ $t('库存数量') }} {{ collect.folderCount }} {{ type === 'skin' ? $t('件') : $t('个') }}</span>
          </div>
        </el-checkbox>
      </div>
    </div>
    <div class="mb-30">
      <div v-if="!adding" class="flex h-36 cursor-pointer items-center justify-center rounded-[4px] border border-blue text-blue" @click="adding = true">
        <i class="iconfont icon-tianjia mr-5"></i>
        <span>{{ $t('新建收藏列表') }}</span>
      </div>
      <el-input v-if="adding" v-model="newCollectName" placeholder="" size="normal" maxlength="12" style="padding-right: 8px">
        <template #suffix>
          <el-button type="primary" style="position: relative; left: 4px" @click="addNewCollect">{{ $t('新建') }}</el-button>
        </template>
      </el-input>
    </div>
    <div class="flex justify-center">
      <el-button size="large" @click="close">{{ $t('取消') }}</el-button>
      <el-button type="primary" size="large" :disabled="vialidateComplete" @click="addItemInCollect">{{ $t('确定') }}</el-button>
    </div>
  </mydialog>
  <div></div>
</template>

<script setup>
import mydialog from '@/components/common/dialog.vue'
import { collectFolderList, addItemIn, batchHandleCollect, createCollectFolder } from '~~/api/collect'
import * as api from '~~/api/inventory'

const { t: $t } = useI18n()

const props = defineProps({
  title: String,
  visible: Boolean,
  width: String,
  type: String,
  id: String
})

const emit = defineEmits(['close'])

const dialogVisible = ref(props.visible)

const collectList = ref([])
const adding = ref(false)
const newCollectName = ref('')
const apiAddLength = ref(0)
const apiRemoveLength = ref(0)

const close = () => {
  dialogVisible.value = false
  adding.value = false
  newCollectName.value = ''
  if (apiAddLength.value) {
    emit('close', true)
  } else {
    if (apiRemoveLength.value) {
      emit('close', false)
    } else {
      const isCollect = originList.value.some(item => item?.isCollect)
      emit('close', isCollect)
    }
  }
}

const vialidateComplete = computed(() => {
  return collectList.value.some(item => !item.folderName) || adding.value
})

const originList = ref([])

watch(
  () => props.visible,
  val => {
    dialogVisible.value = val
    if (val) {
      getCollectList()
    }
  }
)

const addNewCollect = () => {
  if (collectList.value.length >= 30) {
    myMessage({
      type: 'error',
      message: $t('最多只能创建30个收藏夹')
    })
    return
  }
  createCollectFolder({ folder: newCollectName.value, biz: props.type }).then(res => {
    if (res.data) {
      myMessage({
        type: 'success',
        message: '创建成功'
      })
      res.data.isCollect = true
      collectList.value.unshift(res.data)

      newCollectName.value = ''
      adding.value = false
    }
  })

}

const getCollectList = () => {
  collectFolderList({ biz: props.type, elementId: props.id }).then(res => {
    collectList.value = res.data
    originList.value = JSON.parse(JSON.stringify(res.data))
  })
}

const preCheck = async () => {
  if (vialidateComplete.value) {
    myMessage({
      type: 'error',
      message: '请填写完整'
    })
    return
  }
  const unCreateList = collectList.value.filter(item => !item.folderId)
  if (unCreateList.length) {
    for (const item of unCreateList) {
      const res = await createCollectFolder({ folderName: item.folderName, biz: props.type })
    }
  } else {
    addItemInCollect()
  }
}

const addItemInCollect = () => {
  const addCollectList = collectList.value.filter(item => item?.isCollect).map(item => item.folderId)
  const removeCollectList = collectList.value.filter(item => !item?.isCollect).map(item => item.folderId)
  
  batchHandleCollect({ addFolderIds: addCollectList, removeFolderIds: removeCollectList, elementId: props.id, biz: props.type }).then(res => {
    if (res.data) {
      myMessage({
        type: 'success',
        message: '操作成功'
      })
      dialogVisible.value = false
      apiAddLength.value = addCollectList.length
      apiRemoveLength.value = removeCollectList.length
      close()
    }
  })
}
</script>
